var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSDone16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.95 4.33a1.224 1.224 0 0 1 1.709.036 1.19 1.19 0 0 1-.037 1.704l-5.956 5.597a1.234 1.234 0 0 1-1.686 0L2.378 9.222a1.19 1.19 0 0 1-.037-1.704 1.224 1.224 0 0 1 1.71-.036l1.772 1.665z",
  clipRule: "evenodd"
})));
export default SvgIcSDone16;